export const fakeData = [
    {
        id: 0,
        locationTitle: "COX'S BAZAR",
        shortDescription: "Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...",
        destination: "Cox’s Bazar is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts. South of town, the tropical rainforest of Himchari National Park has waterfalls and many birds. North, sea turtles breed on nearby Sonadia Island.",
        thumbnail: 'https://i.ibb.co/h82WD25/Rectangle-1.png',
        mapLocation: {lat: 21.4508945, lng: 91.9678826 },
        hotels: [
            {
                hotelID: 0,
                hotelTitle: "Light bright airy stylish apt & safe peaceful stay",
                hotelImage: "https://i.ibb.co/TtcjbHX/Rectangle-26.png",
                price: "$34",
                rating: '4.9 (44)'
            },
            {
                hotelID: 1,
                hotelTitle: "Apartment in Lost Panorama",
                hotelImage: "https://i.ibb.co/RHyKW5P/Rectangle-27.png",
                price: "$52",
                rating: '4.8 (10)'
            },
            {
                hotelID: 2,
                hotelTitle: "AR Lounge & Pool (r&r + b&b)",
                hotelImage: "https://i.ibb.co/CzWhmVV/Rectangle-28.png",
                price: "$44",
                rating: '4.9 (25)'
            }
        ]
    },
    {
        id: 1,
        locationTitle: "SAJEK",
        shortDescription: "Sajek is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...",
        destination: "Sajek is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts. South of town, the tropical rainforest of Himchari National Park has waterfalls and many birds. North, sea turtles breed on nearby Sonadia Island.",
        thumbnail: 'https://i.ibb.co/KjMJN74/Sajek.png',
        mapLocation: {lat: 23.3813964, lng: 92.2861862 },
        hotels: [
            {
                hotelID: 0,
                hotelTitle: "Light bright airy stylish apt & safe peaceful stay",
                hotelImage: "https://i.ibb.co/TtcjbHX/Rectangle-26.png",
                price: "$34",
                rating: '4.9 (44)'
            },
            {
                hotelID: 1,
                hotelTitle: "Apartment in Lost Panorama",
                hotelImage: "https://i.ibb.co/RHyKW5P/Rectangle-27.png",
                price: "$52",
                rating: '4.8 (10)'
            },
            {
                hotelID: 2,
                hotelTitle: "AR Lounge & Pool (r&r + b&b)",
                hotelImage: "https://i.ibb.co/CzWhmVV/Rectangle-28.png",
                price: "$44",
                rating: '4.9 (25)'
            }
        ]
    },
    {
        id: 2,
        locationTitle: "SUNDARBANS",
        shortDescription: "Sundarbans is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...",
        destination: "Sundarbans is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts. South of town, the tropical rainforest of Himchari National Park has waterfalls and many birds. North, sea turtles breed on nearby Sonadia Island.",
        thumbnail: 'https://i.ibb.co/sRTf0Bv/sundorbon.png',
        mapLocation: {lat: 22.0834915, lng: 88.8520745 },
        hotels: [
            {
                hotelID: 0,
                hotelTitle: "Light bright airy stylish apt & safe peaceful stay",
                hotelImage: "https://i.ibb.co/TtcjbHX/Rectangle-26.png",
                price: "$34",
                rating: '4.9 (44)'
            },
            {
                hotelID: 1,
                hotelTitle: "Apartment in Lost Panorama",
                hotelImage: "https://i.ibb.co/RHyKW5P/Rectangle-27.png",
                price: "$52",
                rating: '4.8 (10)'
            },
            {
                hotelID: 2,
                hotelTitle: "AR Lounge & Pool (r&r + b&b)",
                hotelImage: "https://i.ibb.co/CzWhmVV/Rectangle-28.png",
                price: "$44",
                rating: '4.9 (25)'
            }
        ]
    },
]